import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    width: '100%',
    maxWidth: 500,
    color: "blue"
  },
});

export default function GeoQueryInfo() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      
      <Typography variant="overline" display="block" gutterBottom>
        Please select a region of interest on the map
      </Typography>
     
    </div>
  );
}